import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Input, Output, ChangeDetectorRef, Renderer2 } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AppErrors } from '@fitness-force/errors';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import {
  Class,
  ClassBookingRequest,
  ClassBookingResponse,
  ClassClient,
  Client,
  CompClassRequest,
  MarkClientCheckedinRequest,
  MarkClientNoshowRequest,
  RemoveClientFromClassRequest,
  UpdateClassBooking,
  UpdateMembership,
} from '@fitness-force/models';
import { ClassService, ClassBookingService, ClientService } from '@fitness-force/api';
import { ToastMessageService } from '@fitness-force/api';
import { BehaviorSubject } from 'rxjs';
import { ClassStatus, ClientBookingStatus } from '@fitness-force/enum';
import { TooltipModule } from 'primeng/tooltip';
import { FormControl } from '@angular/forms';
import { DrawerModule } from 'primeng/drawer';
import {  ShortNamePipe } from '@fitness-force/pipes/short-name'
import {  MiniSearchComponent,} from '@fitness-force/common/search';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
@Component({
  selector: 'class-client-booking',
  templateUrl: './class-client-booking.component.html',
  styleUrls: ['./class-client-booking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    SelectModule,
    DividerModule,
    AvatarModule,
    StyleClassModule,
    FormsModule,
    ReactiveFormsModule,
    MiniSearchComponent,
    PopoverModule,
    ScrollPanelModule,
    AvatarModule,
    ShortNamePipe,
    TooltipModule,
    DrawerModule,
    RadioButtonModule,
    ProgressSpinnerModule,
    TranslateModule
],
})
export class ClassClientBookingComponent implements OnInit {
  @Input('tenantId') tenantId: number = 0;
  @Input('classData') classObj: Class;
  @Input('showLeftView') showLeftView: boolean = false;
  @Output('CloseViewClass') hideViewClass: EventEmitter<boolean> = new EventEmitter();
  @Output('UpdateClassData') updateClassData: EventEmitter<any> = new EventEmitter();

  markCompleted: boolean = false;
  markAllAttended: boolean = false;

  cancelClassPopup: boolean = false;
  deleteClassPopup: boolean = false;
  showAddClientConfirmPopup: boolean = false;

  showMiniSearch = new BehaviorSubject<boolean>(true);
  selectedClient: Client | any;

  isClassCompletedOrCancelled: boolean = false;
  selectedMemberStatus: { name: string; status: string; count: number } | any;

  memberstatus = [
    { name: 'Booked', status: ClientBookingStatus.Booked.toString(), count: 0 },
    { name: 'CheckedIn', status: ClientBookingStatus.Attended.toString(), count: 0 },
    { name: 'Cancelled', status: ClientBookingStatus.Cancelled.toString(), count: 0 },
    { name: 'Waitlist', status: ClientBookingStatus.Waitlist.toString(), count: 0 },
    { name: 'NoShow', status: ClientBookingStatus.NoShow.toString(), count: 0 },
  ];

  clients$ = new BehaviorSubject<any[]>([]);
  clientBookingResponse: ClassBookingResponse;
  clientMembershipForm: FormGroup;
  sendGroupMsgs: boolean = false;
  showMedicalAlert: boolean = false;
  clientMedicalDetails: any;
  showAddMemberMsg: boolean = false;
  showCreateProspectPopup$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  showLoader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showCompSessionPopup: boolean;
  complimentoryForm: UntypedFormGroup = new UntypedFormGroup({});
  addToRecurringClassForm:UntypedFormGroup = new UntypedFormGroup({});
  isComplimentoryLoading:boolean=false;

  showRecurringEventUpdatePopup:boolean=false;
  constructor(
    private translate: TranslateService,
    private toastMessageService: ToastMessageService,
    private classService: ClassService,
    public datePipe: DatePipe,
    private classBookingService: ClassBookingService,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private clientService: ClientService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.complimentoryForm = this.fb.group({
      comments: ['', [Validators.required]],
      booking_id: []
    });
    this.addToRecurringClassForm = this.fb.group({updateEvent: ['thisClass', [Validators.required]]});

    this.clientMembershipForm = this.fb.group({});
    this.isClassCompletedOrCancelled =
      this.classObj.status == ClassStatus.Completed.toString() ||
        this.classObj.status == ClassStatus[ClassStatus.Completed] ||
        this.classObj.status == ClassStatus.Cancelled.toString() ||
        this.classObj.status == ClassStatus[ClassStatus.Cancelled] ? true : false;

    this.markCompleted = this.classObj.status == ClassStatus.Completed.toString() || this.classObj.status == ClassStatus[ClassStatus.Completed] ? true : false;
    this.markAllAttended = this.markCompleted;

    if (this.classObj.class_clients) {
      if (this.selectedMemberStatus)
        this.clients$.next(this.classObj.class_clients.filter((c) => c.class_booking_status == this.selectedMemberStatus.status));
      else {
        this.selectedMemberStatus = this.memberstatus.find((m) => m.status == ClientBookingStatus.Booked)!;
        this.clients$.next(this.classObj.class_clients.filter((c) =>
          c.class_booking_status == this.selectedMemberStatus.status &&
          c.class_booking_is_waitlist == false));
      }
      this.UpdateForm();
    }
    else {
      this.selectedMemberStatus = this.memberstatus.find((m) => m.status == ClientBookingStatus.Booked)!;
    }
  }

  UpdateForm() {
    if (this.classObj.class_clients) {
      this.classObj.class_clients.forEach((clt) => {
        if (clt.memberships) {
          clt.selectedMembership = clt.memberships.find((o) => o.is_selected)!;
          this.clientMembershipForm.addControl('clientMembership_' + clt.class_booking_client_Id, new FormControl(clt.selectedMembership));
        } else {
          this.clientMembershipForm.addControl('clientMembership_' + clt.class_booking_client_Id, new FormControl('', []));
        }
      });
      this.clients$.next(
        this.classObj.class_clients.filter((c) => c.class_booking_status == this.selectedMemberStatus.status)
      );
    }
  }

  addToRecurringClass(event:boolean){
    if(event){
      let clientids: number[] = [];
      clientids.push(this.selectedClient.clt_id);
        if(this.GetSelectedUpdateEventFormControlValue == 'thisClass'){
        this.AddClientToClass(clientids, false).then((res: boolean) => {
          if (res) {
            this.classObj.total_booking = this.classObj.total_booking + clientids.length;
          this.handleResponse(this.selectedClient, false);
          this.showLoader$.next(false);
          this.showRecurringEventUpdatePopup = false;
          this.cd.detectChanges();
        }
      });
     }
     else{
        this.AddClientToClass(clientids, false).then((res: boolean) => {
        if (res) {
          this.classObj.total_booking = this.classObj.total_booking + clientids.length;
        this.handleResponse(this.selectedClient, false);
        this.showLoader$.next(false);
        this.showRecurringEventUpdatePopup = false;
        this.cd.detectChanges();
      }
       });
     }
    }
    else{
      this.showRecurringEventUpdatePopup = false;
      this.showMiniSearch.next(true);
      this.selectedClient = null;
      this.showLoader$.next(false);
    }
  }

  AddClient(client: Client) {
    if (client && client.clt_id > 0) {
      this.showMiniSearch.next(false);
      this.showLoader$.next(true);
      this.selectedClient = client;
      let clientids: number[] = [];
      clientids.push(client.clt_id);
      if(this.classObj.recurring_id > 0){
        this.showRecurringEventUpdatePopup = true;
        return;
     }
      if (this.classObj.total_booking >= this.classObj.max_capacity) {
        if (this.classObj.total_waitlist_booking >= this.classObj.max_waitlist) {
          this.showMiniSearch.next(true);
          this.showLoader$.next(false);
          this.selectedClient = null;
          this.translate.get('SCHEDULE.VIEWCLASS.MSG.NO_SLOTS_AVAILABLE').subscribe((translation) => {
            this.toastMessageService.showErrorMessage(translation);
          });
        }
        else
          this.showAddClientConfirmPopup = true;
      } else {
        this.AddClientToClass(clientids, false).then((res: boolean) => {
          if (res) {
            this.classObj.total_booking = this.classObj.total_booking + clientids.length;
            this.handleResponse(client, false);
            this.showLoader$.next(false);
            this.cd.detectChanges();
          }
        });
      }
    } else {
      this.selectedClient = null;
      this.showLoader$.next(false);
      this.showRecurringEventUpdatePopup = false;
    }
  }

  handleResponse(client: any, isWaitlist: boolean) {
    if (this.clientBookingResponse.client_booked_details != null || undefined) {
      const group: any = {};
      this.clientBookingResponse.client_booked_details.forEach((c) => {
        let classCLients: ClassClient = {} as ClassClient;
        classCLients.class_booking_Id = 0;
        classCLients.class_booking_client_Id = c.client_id;
        classCLients.class_booking_status = ClientBookingStatus.Booked;
        classCLients.full_name = client.clt_full_name;
        classCLients.emailid = client.clt_emailid;
        classCLients.mobile_country_code = client.clt_mobile_country_code;
        classCLients.mobile_no = client.clt_mobile_no;
        classCLients.image = client.clt_image;
        classCLients.class_booking_is_first_time_class = c.is_first_time_class;
        classCLients.medical_alert = c.medical_alert;
        classCLients.memberships = c.memberships;
        classCLients.selectedMembership = c.memberships ? c.memberships.find((m) => m.is_selected)! : null;
        classCLients.class_booking_is_waitlist = isWaitlist;
        classCLients.client_status = client.clt_status;
        if (this.classObj.class_clients) {
          this.classObj.class_clients.push(classCLients);
        } else {
          this.classObj.class_clients = [] as ClassClient[];
          this.classObj.class_clients.push(classCLients);
        }
      });
    }
    this.classObj.class_clients.forEach((clt) => {
      if (clt.memberships) {
        clt.selectedMembership = clt.memberships.find((o) => o.is_selected)!;
        this.clientMembershipForm.addControl('clientMembership_' + clt.class_booking_client_Id, new FormControl(clt.selectedMembership, []));
      } else {
        this.clientMembershipForm.addControl('clientMembership_' + clt.class_booking_client_Id, new FormControl('', []));
      }
    });
    //this.getClients();
    this.showAddClientConfirmPopup = false;
    this.updateClassData.emit(this.classObj);
    this.cd.detectChanges();
  }

  AddClientToClass(clientIds: number[], addToWaitList: boolean) {
    let classBookingRequest: ClassBookingRequest = {} as ClassBookingRequest;
    classBookingRequest.client_ids = clientIds;
    classBookingRequest.add_to_waitlist = addToWaitList;
    let promise: Promise<boolean> = new Promise((resolve, reject) => {
      this.classBookingService.BookClientsToClass(this.tenantId, this.classObj.id, classBookingRequest).subscribe({
        next: (data: ClassBookingResponse) => {
          this.clientBookingResponse = data;
          this.translate.get('SCHEDULE.VIEWCLASS.MSG.CLIENT_ADDDED_MSG').subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
          this.showMiniSearch.next(true);
          this.showRecurringEventUpdatePopup = false;
          resolve(true);
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
          this.showMiniSearch.next(true);
          this.showLoader$.next(false);
          this.showRecurringEventUpdatePopup = false;
          resolve(false);
        },
      });
    });
    return promise;
  }

  AddClientToWaitlist() {
    let clientids: number[] = [];
    clientids.push(this.selectedClient.clt_id);
    this.AddClientToClass(clientids, true).then((res: boolean) => {
      if (res) {
        this.classObj.total_waitlist_booking = this.classObj.total_waitlist_booking + clientids.length;
        this.showAddClientConfirmPopup = false;
        this.handleResponse(this.selectedClient, true);
      }
    });
  }

  MarkClientNoshow(client: ClassClient, event: Event) {
    this.addClass(event);
    let clientNoShowRequest: MarkClientNoshowRequest = {} as MarkClientNoshowRequest;
    let clientids: number[] = [];
    clientids.push(client.class_booking_client_Id);
    clientNoShowRequest.client_ids = clientids;
    this.classBookingService.MarkNoShow(this.tenantId, this.classObj.id, clientNoShowRequest)
      .subscribe({
        next: (data: any) => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.MARK_NOSHOW_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          this.classObj.class_clients.forEach((cls) => {
            if (cls.class_booking_client_Id == client.class_booking_client_Id)
              cls.class_booking_status = ClientBookingStatus.NoShow;
          });
          this.remoevClass(event);
        },
        error: (error: AppErrors) => {
          this.remoevClass(event);
          this.ShowToastErrors(error);
        },
      });
  }

  MarkClientCheckedIn(client: ClassClient, event: Event) {
    this.addClass(event);
    let clientCheckedInRequest: MarkClientCheckedinRequest = {} as MarkClientCheckedinRequest;
    let clientids: number[] = [];
    clientids.push(client.class_booking_client_Id);
    clientCheckedInRequest.client_ids = clientids;
    this.classBookingService.MarkCheckedIn(this.tenantId, this.classObj.id, clientCheckedInRequest)
      .subscribe({
        next: (data: any) => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.MARK_CHECKEDIN_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          this.classObj.class_clients.forEach((cls) => {
            if (cls.class_booking_client_Id == client.class_booking_client_Id)
              cls.class_booking_status = ClientBookingStatus.Attended;
          });
          this.clients$.next(this.classObj.class_clients);
          this.updateClassData.emit(this.classObj);
          this.remoevClass(event);
        },
        error: (error: AppErrors) => {
          this.remoevClass(event);
          this.ShowToastErrors(error);
        },
      });
  }

  RemoveClientFromClass(client: ClassClient, event: Event) {
    this.addClass(event);
    let removeClientFromClass: RemoveClientFromClassRequest = {} as RemoveClientFromClassRequest;
    let clientids: number[] = [];
    clientids.push(client.class_booking_client_Id);
    removeClientFromClass.client_ids = clientids;
    this.classBookingService.RemoveClientsToClass(this.tenantId, this.classObj.id, removeClientFromClass)
      .subscribe({
        next: (data: any) => {
          this.translate.get('SCHEDULE.VIEWCLASS.MSG.REMOVE_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          if (client.class_booking_is_waitlist)
            this.classObj.total_waitlist_booking = this.classObj.total_waitlist_booking - clientids.length;
          else
            this.classObj.total_booking = this.classObj.total_booking - clientids.length;

          this.classObj.class_clients.forEach((cls) => {
            if (clientids.includes(cls.class_booking_client_Id))
              cls.class_booking_status = ClientBookingStatus.Cancelled;
          });


          this.clients$.next(this.classObj.class_clients);
          this.updateClassData.emit(this.classObj);
          this.remoevClass(event);
        },
        error: (error: AppErrors) => {
          this.remoevClass(event);
          this.ShowToastErrors(error);
        },
      });
  }

  MarkAllClientsAttended(markAllAttended: boolean) {
    let isValid: boolean = false;
    if (this.classObj.class_clients && this.classObj.class_clients && this.classObj.class_clients.length > 0)
      isValid = this.classObj.class_clients.some((c) => c.class_booking_status.toLowerCase() == ClientBookingStatus.Booked.toLowerCase())
    if (!markAllAttended && isValid) {
      let clients = this.classObj.class_clients.filter((c) => c.class_booking_status.toLowerCase() == ClientBookingStatus.Booked.toLowerCase());
      let clientids = clients.map((s) => { return s.class_booking_client_Id; });
      let clientCheckedInRequest: MarkClientCheckedinRequest = {} as MarkClientCheckedinRequest;
      clientCheckedInRequest.client_ids = clientids;
      this.classBookingService.MarkCheckedIn(this.tenantId, this.classObj.id, clientCheckedInRequest)
        .subscribe({
          next: (data: any) => {
            this.translate.get('SCHEDULE.VIEWCLASS.MSG.MARK_CHECKEDIN_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            this.classObj.class_clients.map((c) => (c.class_booking_status = ClientBookingStatus.Attended));
            this.markAllAttended = true;
            this.clients$.next(this.classObj.class_clients);
            this.updateClassData.emit(this.classObj);
          },
          error: (error: AppErrors) => {
            this.ShowToastErrors(error);
          },
        });
    }
    else {
      this.translate.get('SCHEDULE.VIEWCLASS.MSG.NO_CLIENTS_TO_MARK_ATTEND')
        .subscribe((translation) => {
          this.toastMessageService.showSuccess(translation);
        });
    }
  }

  MarkAsCompSession(client:ClassClient,event:Event){
    console.log(client);
    this.selectedClient = client;
    this.showCompSessionPopup = true;
  }

  closeCompSessionPopup(){
    this.showCompSessionPopup = false;
    this.selectedClient = null;
    this.complimentoryForm.reset();
  }

  ComplimentoryClass(form: any) {
    this.isComplimentoryLoading=true;
    let compClassRequest: CompClassRequest = {} as CompClassRequest;
    compClassRequest.comment = form.value.comments;
    this.classBookingService.MarkComplimentoryClass(this.tenantId, this.selectedClient.class_booking_client_Id, this.selectedClient.class_booking_Id, compClassRequest)
      .subscribe({
        next: async (data: any) => {
          this.isComplimentoryLoading=false;
          this.translate.get('CLIENT_BOOKING.COMP_COMPLETED')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.showCompSessionPopup = false;
          this.selectedClient = null;
          this.cd.detectChanges();
        },
        error: (error: AppErrors) => {
          this.isComplimentoryLoading=false;
          this.ShowToastErrors(error);
          this.showCompSessionPopup = false;
          this.selectedClient = null;
          this.cd.detectChanges();
        },
      });
  }

  MarkClassComplete(markCompleted: boolean) {
    if (!markCompleted) {
      this.classService.MarkClassComplete(this.tenantId, this.classObj.id).subscribe({
        next: (data: any) => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.COMPLETE_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.markCompleted = true;
          this.classObj.status = ClassStatus.Completed;
          this.updateClassData.emit(this.classObj);
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
          this.deleteClassPopup = false;
        },
      });
    }
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e.errorMessage);
      });
    } else {
      this.toastMessageService.showErrorMessage(error);
    }
  }

  ClosePopup() {
    this.hideViewClass.emit(true);
  }

  ToggleButton(status: any) {
    this.selectedMemberStatus = status;
    //this.getClients();
  }

  filterClients(event: any) {
    this.ToggleButton(event.value);
  }

  ChangeMembership(event: any, client: ClassClient) {
    let updateRequest: UpdateClassBooking = {} as UpdateClassBooking;
    updateRequest.clients_with_memberships = [] as UpdateMembership[];
    let updateClientMembership: UpdateMembership = {} as UpdateMembership;
    updateClientMembership.client_id = client.class_booking_client_Id;
    updateClientMembership.subscription_id = event.value.subscription_id;
    updateClientMembership.membership_id = event.value.id;
    updateRequest.clients_with_memberships.push(updateClientMembership);
    this.classBookingService.UpdateClientmembership(this.tenantId, this.classObj.id, updateRequest)
      .subscribe({
        next: (data: ClassBookingResponse) => {
          this.clientBookingResponse = data;
          this.translate.get('SCHEDULE.VIEWCLASS.MSG.UPDATE_MEMBERSHIP_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.updateClassData.emit(this.classObj);
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  getClientMembership(clientId: number) {
    return this.clientMembershipForm.get('clientMembership_' + clientId)!.value;
  }

  get getClients() {
    if (this.classObj.class_clients) {
      let filterClients = [];
      if (this.selectedMemberStatus && this.selectedMemberStatus.status == ClientBookingStatus.Waitlist.toString())
        filterClients = this.classObj.class_clients.filter((c) => c.class_booking_is_waitlist == true && c.class_booking_status == ClientBookingStatus.Booked);

      else if (this.selectedMemberStatus && this.selectedMemberStatus.status != ClientBookingStatus.Waitlist.toString() && this.selectedMemberStatus.status != ClientBookingStatus.Booked.toString()) {
        filterClients = this.classObj.class_clients.filter(c => c.class_booking_status == this.selectedMemberStatus.status);
      }
      else {
        this.selectedMemberStatus = this.memberstatus.find((m) => m.status == ClientBookingStatus.Booked)!;
        filterClients = this.classObj.class_clients.filter((c) => c.class_booking_status == this.selectedMemberStatus.status && c.class_booking_is_waitlist == false);
      }
      filterClients.length == 0 ? this.showAddMemberMsg = true : this.showAddMemberMsg = false;
      this.clients$.next(filterClients);
      this.showAddMemberMsg = false;
      return this.clients$.value;
    }
    else {
      this.showAddMemberMsg = true;
      return [];
    }
  }

  clientStatus(client: any | null): string {
    if (client && (client.client_status || (client as any)?.client_status))
      return this.clientService.getClientStatusHtml(
        (client.client_status || (client as any)?.client_status).toString()
      );
    else return '';
  }

  GetClietMedicalDetails(client: any) {
    this.clientMedicalDetails = client;
    this.showMedicalAlert = true;
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  get clientBookingStatus() {
    return ClientBookingStatus;
  }

  get GetMemberStatus() {
    if (this.classObj.class_clients) {
      this.memberstatus.filter((s) => {
        if (s.status == ClientBookingStatus.Waitlist.toString()) {
          s.count = this.classObj.class_clients.filter(
            (c) =>
              c.class_booking_is_waitlist &&
              c.class_booking_status == ClientBookingStatus.Booked
          ).length;
        } else if (s.status == ClientBookingStatus.Booked.toString()) {
          s.count = this.classObj.class_clients.filter(
            (c) => c.class_booking_status == s.status && c.class_booking_is_waitlist == false
          ).length;
        }
        else {
          s.count = this.classObj.class_clients.filter(
            (c) => c.class_booking_status == s.status
          ).length;
        }
      });
      return this.memberstatus;
    } else return this.memberstatus;
  }

  createProspect(event: any) {
    this.showCreateProspectPopup$.next(true);
  }

  hidePopup(clientId: number) {
    this.showCreateProspectPopup$.next(false);
  }

  addClass(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const classesToAdd = ['fa-spin', 'fa-spinner'];
    classesToAdd.forEach(className => {
      this.renderer.addClass(clickedElement.firstElementChild, className);
    });
  }

  remoevClass(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const classesToAdd = ['fa-spin', 'fa-spinner'];
    classesToAdd.forEach(className => {
      this.renderer.removeClass(clickedElement.firstElementChild, className);
    });
  }

  get GetSelectedUpdateEventFormControlValue(): any {
    return this.addToRecurringClassForm.get('updateEvent')?.value;
  }

}